import type { FaireProductEntity } from "../../entity_types/product";

export const p_7gmksayps6: FaireProductEntity = {
  token: "p_7gmksayps6",
  type: "product",
  name: "Tropics Face Mask - Vegan & Cruelty-Free Mini | Travel ",
  brandName: "Bella & Bear",
  imageUrl:
    "https://cdn.faire.com/fastly/b228ea94a2139f43c5a33a5279ae4ea41e2605698a68cf55fd2a21929f7a553b.png",
  priceDollars: 1.74,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/1c5e910ec6dfcc81389b94f56f8fd01536a7d8dd14ba74d1c6280b9224c093d7.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
